import {DetailsList, IconButton} from "@fluentui/react";
import * as React from "react";
import {useEffect, useState, useContext} from "react";
import {SelectionMode} from "@fluentui/react";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import AddContractor from "../Panel/Contractor/AddContractor";
import EditContractor from "../Panel/Contractor/EditContractor";
import {useOutletContext} from "react-router-dom";

function Contractor(props) {
    const [user] = useContext(AuthContext);
    const [Contractors, setContractors] = useState([]);
    const [refresh, setRefresh] = useState(0);
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch("/api/contractor", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setContractors(data) })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [refresh, user.token]);
    const [editContractor, setEditContractor] = useState(false);
    const [addContractor, setAddContractor] = useState(false);
    const actions = useOutletContext();
    useEffect(() => {
        actions([
            {
                key: 'addContractor',
                text: 'Dodaj',
                iconProps: { iconName: 'Add' },
                onClick: () => setAddContractor(true)
            }
        ]);
        return actions;
    }, []);

    const columns = [
        {
            key: 'name',
            name: 'Nazwa',
            ariaLabel: 'Nazwa Wykonawcy',
            fieldName: 'name',
            minWidth: 210,
            isRowHeader: true,
            isResizable: true,
        },
        {
            key: 'email',
            name: 'Email',
            ariaLabel: 'E-mail',
            fieldName: 'email',
            minWidth: 150,
            isRowHeader: true,
            isResizable: true,
        },
        {
            key: 'tasks',
            name: 'Zadania',
            ariaLabel: 'Zadania',
            fieldName: 'tasks',
            minWidth: 60,
            maxWidth: 60,
            onRender: (item) => (<a href={`/api/report/contractor/${item.id}/tasks?auth=${user.token}`} target={'_blank'}>
                <IconButton iconProps={{iconName: 'PDF'}} title='PDF'/></a>)
        },
        {
            key: 'edit',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'edit',
            minWidth: 90,
            maxWidth: 90,
            onRender: (item) => (<span>
                <IconButton iconProps={ {iconName: 'edit' }} title='Edytuj' onClick={() => setEditContractor(item)}/>
                <IconButton iconProps={ {iconName: 'delete' }} title='Usuń' onClick={() => _deleteContractor(item)}/>
            </span>)
        }
    ];
    const _deleteContractor = (item) => {
        fetch(`/api/contractor/${item.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { setRefresh(refresh + 1) })
            .catch(err => { console.log(err) })
    }

    return (
        <AppContent title={'Wykonawcy'}>
            <DetailsList items={Contractors} columns={columns} selectionMode={SelectionMode.none}/>
            <AddContractor add={addContractor} onSuccess={() => setRefresh(refresh + 1)} dismissPanel={() => setAddContractor(false)} />
            <EditContractor add={editContractor} onSuccess={() => setRefresh(refresh + 1)} dismissPanel={() => setEditContractor(false)} />
        </AppContent>
    );
}

export default Contractor;